<svg viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 1L1.07917 5.83739C1.05428 5.85779 1.03435 5.88283 1.0207 5.91086C1.00706 5.93889 1 5.96927 1 6C1 6.03073 1.00706 6.06111 1.0207 6.08914C1.03435 6.11717 1.05428 6.14221 1.07917 6.16261L7 11" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
